/* eslint-disable import/prefer-default-export */
import { config } from './config';

export { config };
